import React from 'react'
import { StyleSheet } from 'react-native'

import { MotiView } from '@zet/common/components/motiView'
import { Stack, XStack, YStack, colors as zetColors } from '@zet/design-system'
import { Skeleton } from 'moti/skeleton'

const LoadingScreen = () => {
  return (
    <YStack className="flex flex-1">
      <MotiView
        transition={{
          type: 'timing',
        }}
        animate={{ backgroundColor: zetColors.neutral.white100 }}
        className=""
      >
        <XStack className="px-3 py-4" style={styles.containerStack}>
          <Skeleton colorMode={'light'} width={'83%'} height={160} />
          <Skeleton colorMode={'light'} width={'100%'} height={160} />
        </XStack>
        <Stack className="my-6 px-3">
          <Skeleton colorMode={'light'} width={'100%'} height={50} />
        </Stack>
        <Stack className="my-2 flex w-full flex-row justify-between px-3">
          <Stack className="mr-4">
            <Skeleton colorMode={'light'} width={152} height={120} />
          </Stack>
          <Stack>
            <Skeleton colorMode={'light'} width={152} height={120} />
          </Stack>
        </Stack>
        <Stack className="my-2 flex w-full flex-row justify-between px-3">
          <Stack className="mr-4">
            <Skeleton colorMode={'light'} width={152} height={120} />
          </Stack>
          <Stack>
            <Skeleton colorMode={'light'} width={152} height={120} />
          </Stack>
        </Stack>
      </MotiView>
    </YStack>
  )
}

const styles = StyleSheet.create({
  containerStack: { backgroundColor: zetColors.tertiary[150] },
})

export { LoadingScreen }
